import classNames from 'classnames'
import React, { ReactNode } from 'react'

export interface LayoutTwoSectionsProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  rightContainer: ReactNode
  className: string
  /**
   * Lets each section shrink below its own content, so a child can hold the scrollbar instead of
   * growing the page. Without it the sections keep the default minimum size and never scroll.
   */
  scrollableSections?: boolean
}

export const LayoutTwoSections = ({
  children,
  rightContainer,
  className,
  scrollableSections,
  ...props
}: LayoutTwoSectionsProps) => {
  const sectionClassName = scrollableSections ? 'flex flex-col min-h-0 min-w-0' : undefined

  return (
    <div className="flex flex-col flex-1 min-h-0 h-full">
      <div
        {...props}
        className={classNames('grid flex-1 min-h-0', className)}
        style={{
          ...props.style
        }}
      >
        <div className={classNames('border-r border-solid border-gray-300 mr-6 pr-6', sectionClassName)}>
          {children}
        </div>
        <div className={sectionClassName}>{rightContainer}</div>
      </div>
    </div>
  )
}
